import { FORM_LABELS, NAMES } from '../store/constants'

/**
 * Class representing IntervalFormatter for formatting interval objects.
 *
 * @author Isadora Botassari
 * @class
 * @name IntervalFormatter
 */
export default class IntervalFormatter {

    static visualizationIntervalFormatter = (interval) => {

        const operator = interval.operator
        let formattedInterval = interval

        if (operator === FORM_LABELS.GREATER_OR_EQUAL)
            formattedInterval = { ...interval, minValue: interval.minValue, maxValue: 100 }

        if (operator === FORM_LABELS.LESSER_OR_EQUAL)
            formattedInterval = { ...interval, minValue: 0, maxValue: interval.maxValue }

        if (operator === FORM_LABELS.NONE)
            formattedInterval = { ...interval, minValue: 0, maxValue: 100 }

        return formattedInterval
    }

    static tableIntervalFormatter = (intervalList) => {

        const formattedIntervalList = intervalList.map(interval => {

            const operator = interval.operator

            let minValue = interval.minValue
            let maxValue = interval.maxValue

            if (operator === FORM_LABELS.GREATER_OR_EQUAL)
                maxValue = "-"

            if (operator === FORM_LABELS.LESSER_OR_EQUAL)
                minValue = "-"

            if (operator === FORM_LABELS.NONE) {
                minValue = "-"
                maxValue = "-"
            }

            return {
                ...interval,
                minValue,
                maxValue
            }

        })

        return formattedIntervalList
    }

    static postIntervalFormatter = (intervalList) => {

        const formattedIntervalList = intervalList.map(interval => {

            const operator = interval.operator
            const action = interval.action

            let formattedInterval = {
                consumptionRangeId: interval.consumptionRangeId,
                minValue: interval.minValue,
                maxValue: interval.maxValue,
                action: interval.percentage,
                color: interval.color
            }

            switch (operator) {

                case FORM_LABELS.GREATER_OR_EQUAL:
                    formattedInterval.maxValue = null
                    break
                case FORM_LABELS.LESSER_OR_EQUAL:
                    formattedInterval.minValue = null
                    break
                case FORM_LABELS.NONE:
                    formattedInterval.minValue = null
                    formattedInterval.maxValue = null
                    break
            }

            switch (action) {
                case FORM_LABELS.RAISE_LIMIT:
                    formattedInterval.action = (1 + (formattedInterval.action / 100)).toFixed(2)
                    break
                case FORM_LABELS.REDUCE_LIMIT:
                    formattedInterval.action = (1 - (formattedInterval.action / 100)).toFixed(2)
                    break
                case FORM_LABELS.KEEP_LIMIT:
                    formattedInterval.action = 1
                    break
                case FORM_LABELS.ZERO_LIMIT:
                    formattedInterval.action = 0
                    break
            }

            return formattedInterval

        })

        return formattedIntervalList

    }

    // Backend Data To Frontend Visualization
    static backToFrontIntervalFormatter = (consumptionRanges) => {

        const formattedIntervalList = consumptionRanges.map(range => {

            let formattedInterval = {
                consumptionRangeId: range.consumptionRangeId,
                operator: "",
                operatorLabel: "",
                minValue: range.minValue,
                maxValue: range.maxValue,
                action: range.action,
                actionLabel: "",
                percentage: "",
                color: range.color
            }
            let newPercentage

            // Set Action
            if (range.action > 1) {
                newPercentage = ((range.action - 1) * 100).toFixed(0)
                formattedInterval = { ...formattedInterval, action: FORM_LABELS.RAISE_LIMIT, actionLabel: NAMES.RAISE_LIMIT, percentage: newPercentage }
            }
            if (range.action < 1 && range.action > 0) {
                newPercentage = ((1 - range.action) * 100).toFixed(0)
                formattedInterval = { ...formattedInterval, action: FORM_LABELS.REDUCE_LIMIT, actionLabel: NAMES.REDUCE_LIMIT, percentage: newPercentage }
            }
            if (range.action === 1) {
                formattedInterval = { ...formattedInterval, action: FORM_LABELS.KEEP_LIMIT, actionLabel: NAMES.KEEP_LIMIT, percentage: 0 }
            }
            if (range.action === 0) {
                formattedInterval = { ...formattedInterval, action: FORM_LABELS.ZERO_LIMIT, actionLabel: NAMES.ZERO_LIMIT, percentage: 0 }
            }

            // Set Operator
            if (range.maxValue === null) {
                formattedInterval = { ...formattedInterval, operator: FORM_LABELS.GREATER_OR_EQUAL, operatorLabel: NAMES.GREATER_OR_EQUAL, maxValue: 100 }
            }
            if (range.minValue === null) {
                formattedInterval = { ...formattedInterval, operator: FORM_LABELS.LESSER_OR_EQUAL, operatorLabel: NAMES.LESSER_OR_EQUAL, minValue: 0 }
            }

            if (range.minValue !== null && range.maxValue !== null) {
                formattedInterval = { ...formattedInterval, operator: FORM_LABELS.BETWEEN, operatorLabel: NAMES.BETWEEN }
            }

            if (range.minValue === null && range.maxValue === null)
                formattedInterval = { ...formattedInterval, operator: FORM_LABELS.NONE, operatorLabel: NAMES.NONE, minValue: 0, maxValue: 100 }

            return formattedInterval

        })

        return formattedIntervalList

    }

}